import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { cn } from '@/shared/lib/utils'

export function HorizonCategoryCard({
  to,
  title,
  children,
  className,
}: {
  to: string
  title: string
  children?: ReactNode
  className?: string
}) {
  return (
    <Link
      to={to}
      className={cn(
        'horizon-category-card flex h-[76px] w-[88px] shrink-0 flex-col items-center justify-center gap-1.5 rounded-[var(--brand-radius-card)] border border-[var(--brand-border-soft)] bg-[var(--brand-surface)] px-2 text-center text-[var(--brand-text-primary)] no-underline transition hover:-translate-y-0.5 hover:border-[var(--brand-primary)] hover:shadow-[var(--brand-shadow-1)] sm:h-24 sm:w-auto sm:min-w-[7.5rem] sm:flex-1 sm:px-3',
        className,
      )}
    >
      {children ? (
        <span className="inline-flex size-6 items-center justify-center text-[var(--brand-primary-strong)] sm:size-7 [&_svg]:size-[22px] sm:[&_svg]:size-6">
          {children}
        </span>
      ) : null}
      <span className="line-clamp-2 text-[12px] font-semibold leading-tight sm:text-sm">{title}</span>
    </Link>
  )
}
